export const GET_FOLDERS = "GET_FOLDERS";
export const GET_FOLDERS_SUCCESS = "GET_FOLDERS_SUCCESS";
export const GET_FOLDERS_FAIL = "GET_FOLDERS_FAIL";

export const CREATE_FOLDER = "CREATE_FOLDER";
export const CREATE_FOLDER_SUCCESS = "CREATE_FOLDER_SUCCESS";
export const CREATE_FOLDER_FAIL = "CREATE_FOLDER_FAIL";

export const GET_FOLDER_FILES = "GET_FOLDER_FILES";
export const GET_FOLDER_FILES_SUCCESS = "GET_FOLDER_FILES_SUCCESS";
export const GET_FOLDER_FILES_FAIL = "GET_FOLDER_FILES_FAIL";

export const ADD_FILE_TO_FOLDER = "ADD_FILE_TO_FOLDER";
export const ADD_FILE_TO_FOLDER_SUCCESS = "ADD_FILE_TO_FOLDER_SUCCESS";
export const ADD_FILE_TO_FOLDER_FAIL = "ADD_FILE_TO_FOLDER_FAIL";

export const DELETE_FOLDER_FILES = "DELETE_FOLDER_FILES";
export const DELETE_FOLDER_FILES_SUCCESS = "DELETE_FOLDER_FILES_SUCCESS";
export const DELETE_FOLDER_FILES_FAIL = "DELETE_FOLDER_FILES_FAIL";

export const DELETE_FOLDER = "DELETE_FOLDER";
export const DELETE_FOLDER_SUCCESS = "DELETE_FOLDER_SUCCESS";
export const DELETE_FOLDER_FAIL = "DELETE_FOLDER_FAIL";

export const ASSIGN_FOLDERS = "ASSIGN_FOLDERS";
export const ASSIGN_FOLDERS_SUCCESS = "ASSIGN_FOLDERS_SUCCESS";
export const ASSIGN_FOLDERS_FAIL = "ASSIGN_FOLDERS_FAIL";

export const GET_ASSIGNED_MEMBERS = "GET_ASSIGNED_MEMBERS";
export const GET_ASSIGNED_MEMBERS_SUCCESS = "GET_ASSIGNED_MEMBERS_SUCCESS";
export const GET_ASSIGNED_MEMBERS_FAIL = "GET_ASSIGNED_MEMBERS_FAIL";

export const UPDATE_FOLDER_PERMISSION = "UPDATE_FOLDER_PERMISSION";
export const UPDATE_FOLDER_PERMISSION_SUCCESS = "UPDATE_FOLDER_PERMISSION_SUCCESS";
export const UPDATE_FOLDER_PERMISSION_FAIL = "UPDATE_FOLDER_PERMISSION_FAIL";

export const REMOVE_FOLDER_USER = "REMOVE_FOLDER_USER";
export const REMOVE_FOLDER_USER_SUCCESS = "REMOVE_FOLDER_USER_SUCCESS";
export const REMOVE_FOLDER_USER_FAIL = "REMOVE_FOLDER_USER_FAIL";

export const RENAME_FOLDER = "RENAME_FOLDER";
export const RENAME_FOLDER_SUCCESS = "RENAME_FOLDER_SUCCESS";
export const RENAME_FOLDER_FAIL = "RENAME_FOLDER_FAIL";
